import { MainLayout } from "components/layouts";
import NewsForm from "./NewsForm";
import { useTranslation } from "react-i18next";

import "suneditor/dist/css/suneditor.min.css";
import { Breadcrumb, Flex, Space } from "antd";

const NewsEdit = (props) => {
  const { t } = useTranslation();

  return (
    <MainLayout>
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("news_policy.header"), href: "/news_policy/news" },
            { title: t("news_list.header"), href: "/news_policy/news" },
            { title: t("common.edit") },
          ]} />
          <h2>{t("common.edit")}</h2>
        </Flex>
        <NewsForm {...props} />
      </Space>
    </MainLayout>
  );
};

export default NewsEdit;
